import React from 'react';
import { useFormContext, useController } from 'react-hook-form';
import { TextField } from 'edenred-ui';

import { createRules } from '@epi-forms/helpers';
import {
  maxLength,
  required as requiredValidation
} from '@epi-helpers/formHelpers/validators';
import { IPersonalDataField } from '@epi-models/pages/Beneficiaries';

export const PersonalDataField = ({
  label,
  validate,
  name,
  required = false,
  disabled = false
}: IPersonalDataField) => {
  const { control } = useFormContext();
  const defaultValidators = [requiredValidation, maxLength(50)];
  const rules = createRules(validate || defaultValidators);

  const {
    field: { onChange, value },
    fieldState: { error }
  } = useController({
    name,
    control,
    rules
  });
  return (
    <TextField
      id={name}
      label={label}
      value={value ?? ''}
      onChange={onChange}
      readOnly={disabled}
      error={!!error}
      helperText={error?.message}
      required={required}
    />
  );
};
